import { Machine, MachineType } from "../model/machine";
import { Dict } from "./dict";
import { Translates } from "./i18n";

export enum MachineFailureTypes {
    Cosmetic, // Kosmetyczna
    Urgent, // Pilna
    Critical // Krytyczna
}

export enum MachineFailureCategory {
    Construction = 'construction',
    Electronic = 'electronic',
    Engine = 'engine',
    ErrorCode = 'errorcode',
    Hydraulics = 'hydraulics',
    Mechanical = 'mechanical',
    Other = 'other',
    Wheel = 'wheel',
    Lamp = 'lamp',
}

type MachineFailureCategoryFormsRows = Record<string, string[]>;

export var MachineFailureCategoryForms: MachineFailureCategoryFormsRows = {
    [MachineFailureCategory.Engine]: ["no_operation", "leaks", "unusual_noises", "overheating", "other_malfunction"],
    [MachineFailureCategory.Lamp]: ["work_lights", "blue_spot", "warning_lights", ]
}

export class MachineRepository {

    constructor() {}

    failureTypes():MachineFailureTypes[] {
        return [
            MachineFailureTypes.Cosmetic, 
            MachineFailureTypes.Urgent, 
            MachineFailureTypes.Critical, 
        ]
    }
    
    listFailureCategories(): MachineFailureCategory[] {
        return [
            MachineFailureCategory.Construction,
            MachineFailureCategory.Electronic,
            MachineFailureCategory.Engine,
            MachineFailureCategory.ErrorCode,
            MachineFailureCategory.Hydraulics,
            MachineFailureCategory.Mechanical,
            MachineFailureCategory.Other,
            MachineFailureCategory.Wheel,
            MachineFailureCategory.Lamp,
        ]
    }
    
    failureCategoriesQuestions(category: MachineFailureCategory): string[] | undefined {
        return MachineFailureCategoryForms[category]
    }

    async types():Promise<MachineType[]> {
        return fetch('/api/communal/machines/types').then((response) => { 
            return response.json()
        });
    }

    // async list():Promise<Machine[]> {
    //     return fetch('/api/schema/machines').then((response) => { 
    //         return response.json()
    //     });
    // }

    // async byCompany(cid: string):Promise<Machine[]> {
    //     return fetch(`/api/schema/machines/bycompany/${cid}`).then((response) => { 
    //         return response.json()
    //     });
    // }

    // async imeis():Promise<string[]> {
    //     return fetch('/api/schema/machines/options/imeis').then((response) => { 
    //         return response.json()
    //     });
    // }

    // async byId(id: string):Promise<Machine> {
    //     return fetch(`/api/schema/machines/byid/${id}`).then((response) => { 
    //         return response.json()
    //     });
    // }

    // async qr(id: string):Promise<string> {
    //     return fetch(`/api/communal/qr/forcompany/${id}`).then((response) => { 
    //         return response.json()
    //     });
    // }

    
}